import { Button } from 'blaze-ui/Button'
import { Upload5 } from 'blaze-ui/icons'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import Styles from './BrandVisualStyleSelection.module.scss'
import cx from 'classnames'
import { FileTrigger } from 'components/FileTrigger/FileTrigger'
import { useImportMediaFiles } from 'hooks/useImportMediaFiles'
import { MediaFile } from 'components/VisualStylePreviewCarousel/VisualStylePreviewCarousel'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'

export interface SelectionStageProps {
  onNext: () => void
  onSelectImage: (image: MediaFile) => void
  onBack: () => void
}

export const SelectionStage = ({ onNext, onSelectImage, onBack }: SelectionStageProps) => {
  const { uploadImageFilesWithoutLoadingToast, isUploading } = useImportMediaFiles(false)

  return (
    <div className={Styles.selectImageStep}>
      <div className={Styles.leftSide}>
        <div className={Styles.title}>
          <Heading level={1} color="var(--dark-80)">
            Professional photography from any source
          </Heading>
          <div className={Styles.description}>
            <Text variant="primary" color="var(--dark-40)">
              Next, we'll create a professional visual style for all your content
            </Text>
          </div>
        </div>
        <div className={Styles.content}>
          <div className={Styles.originImageContainer}>
            <img
              src="https://res.cloudinary.com/almanac/image/upload/v1765916695/blaze_assets/virtual_marketer/onboarding/image_709_fpar2m.png"
              alt="demo origin"
              className={Styles.originImage}
            />
            <div className={Styles.tryYourOwnButtonContainer}>
              <FileTrigger
                accept={['image/*']}
                allowsMultiple={false}
                onSelect={async (files) => {
                  if (!files) return
                  const mediaFiles = await uploadImageFilesWithoutLoadingToast(Array.from(files))
                  const image = {
                    id: mediaFiles?.[0]?.id,
                    url: mediaFiles?.[0]?.url,
                    type: mediaFiles?.[0]?.mime_type?.startsWith('video') ? 'video' : 'image',
                  }
                  onSelectImage(image as MediaFile)
                }}
              >
                <div className={Styles.tryYourOwnButtonContent}>
                  <Button
                    variant="secondary"
                    size="xl"
                    aria-label="try your own"
                    frontIcon={Upload5}
                    isDisabled={isUploading}
                  >
                    {isUploading ? (
                      <>
                        Uploading
                        <LoadingEllipses />
                      </>
                    ) : (
                      'Try Your Own'
                    )}
                  </Button>
                </div>
              </FileTrigger>
            </div>
            <div className={cx(Styles.sourceTag, Styles.imageTag)}>Source Image</div>
          </div>
        </div>
        <div className={Styles.footer}>
          <Button variant="tertiary" size="lg" onPress={onBack} isDisabled={isUploading}>
            Back
          </Button>
          <Button size="lg" variant="secondary" onPress={onNext} isDisabled={isUploading}>
            Choose style selection
          </Button>
        </div>
      </div>
      <div className={Styles.transformedImageContainer}>
        <img
          src="https://res.cloudinary.com/almanac/image/upload/v1765917778/blaze_assets/virtual_marketer/onboarding/image_708_xre8nh.png"
          alt="demo transformed"
          className={cx(Styles.transformedImage, Styles.visible)}
        />
        <div className={cx(Styles.imageTag, Styles.generatedTag)}>Generated Image</div>
      </div>
    </div>
  )
}
